<div [ngClass]="imageModel.isSelected ? 'model-item-container selected' : 'model-item-container'">
  <img [src]="imageModel.isSelected ? './assets/ui/svg/blue/' + imageModel.img : './assets/ui/svg/grey/' + imageModel.img">
  <p>{{imageModel.name}}</p>
  <app-round-checkbox [id]="imageModel.id" [isSelected]="imageModel.isSelected" (click)="clicked()"></app-round-checkbox>
</div>
